import { isDefined, userMoneyVisibleAtom } from '@eih-netbroker/common';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { useAtom } from 'jotai';
import { CSSProperties, FC, PropsWithChildren } from 'react';
import { cssWhen } from '../../utils/themeUtils';
import classes from './MoneyMask.module.scss';

export type MoneyMaskProps = {
  size?: string | number;
  className?: string;
  isInline?: boolean;
  isInverse?: boolean;
  bypass?: boolean;
};

export const MoneyMask: FC<MoneyMaskProps> = ({ size, className, isInline, isInverse }) => {
  const style: CSSProperties | undefined = isDefined(size) ? { width: size } : undefined;
  const computedClassName = cssWhen(
    classes.mask,
    className,
    [isInline, classes.inline],
    [isInverse, classes.inverse, classes.normal],
  );

  return (
    <div
      className={computedClassName}
      style={style}
    >
      &nbsp;
    </div>
  );
};

export type MoneyMaskHOCProps = PropsWithChildren & MoneyMaskProps;

export const MoneyMaskHOC: FC<MoneyMaskHOCProps> = ({ children, bypass, ...props }) => {
  // Only reading this value, no need to go through useUserSettings
  const [isUserMoneyVisible] = useAtom(userMoneyVisibleAtom);
  if (isUserMoneyVisible || bypass) {
    return children;
  }

  return <MoneyMask {...props} />;
};

export function moneyMaskCellRenderer(params: GridRenderCellParams) {
  return (
    <MoneyMaskHOC
      isInline
      isInverse
      size={40}
    >
      {params.formattedValue}
    </MoneyMaskHOC>
  );
}
